import "react-phone-number-input/style.css";
import { Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./assets/css/custom.css";
import RedirectStaffOnboarding from "./components/auth/Middleware/RedirectStaffOnboarding";
import RequireAuth from "./components/auth/Middleware/RequireAuth";
import Dashboard from "./pages/admin/Dashboard";
import Main from "./pages/admin/Main";
import AddOffice from "./pages/admin/office/AddOffice";
import OfficeDetails from "./pages/admin/office/OfficeDetails";
import OfficeList from "./pages/admin/office/OfficeList";
import AddContactInformation from "./pages/admin/staff/AddContactInfo";
import AddEducationInfo from "./pages/admin/staff/AddEducationInfo";
import AddEmploymentInfo from "./pages/admin/staff/AddEmploymentInfo";
import AddGuarantorInfo from "./pages/admin/staff/AddGuarantorInfo";
import AddNextOfKin from "./pages/admin/staff/AddNextOfKin";
import AddStaff from "./pages/admin/staff/AddStaff";
import AddWorkExperience from "./pages/admin/staff/AddWorkExperience";
import ListOfStaff from "./pages/admin/staff/ListOfStaff";
import StaffProfile from "./pages/admin/staff/StaffProfile";
import Error404 from "./pages/error/Error404";
import Login from "./pages/guest/Login";
// import CustomerOverview from "./pages/admin/customer/CustomerOverview";
import CreatePermission from "./components/settings/CreatePermission";
// import Accounting from "./pages/admin/accounting/Accounting";
import AddCustomer from "./pages/admin/customer/AddCustomer";
import AllCustomer from "./pages/admin/customer/AllCustomer";
import CorporateCustomerTable from "./pages/admin/customer/CorporateCustomerTable";
import CustomerProfile from "./pages/admin/customer/CustomerProfile";
import PolicyApplicationOverview from "./pages/admin/customer/PolicyApplicationOverview";
import PolicyApplicationSettings from "./pages/admin/customer/PolicyApplicationSettings";
import AllPolicy from "./pages/admin/policy/AllPolicy";
import EditPolicy from "./pages/admin/policy/EditPolicy";
import AddClause from "./pages/admin/settings/AddClause";
import PreloadedClauseDetail from "./pages/admin/settings/PreloadedClauseDetail";
import PreloadedClauses from "./pages/admin/settings/PreloadedClauses";
import Settings from "./pages/admin/settings/Settings";
import AddUser from "./pages/admin/user/AddUser";
import AllUser from "./pages/admin/user/AllUser";
import EditUser from "./pages/admin/user/EditUser";
import UserProfile from "./pages/admin/user/UserProfile";
// import Commissions from "./pages/admin/commission/Commissions";
// import AddCommission from "./pages/admin/commission/AddCommission";
import AppliedPolicies from "./pages/admin/customer/AppliedPolicies";
// import CommissionDetails from "./pages/admin/commission/CommissionDetails";
import PolicyInformation from "./components/customer/customer-proofile/individual-customer/PolicyInformation";
import CustomerPolicyView from "./pages/admin/customer/CustomerPolicyView";
import EditAppliedPolicy from "./pages/admin/customer/EditAppliedPolicy";
import PolicyAttachmentSearch from "./pages/admin/customer/PolicyAttachmentSearch";
import PolicySchedule from "./pages/admin/customer/PolicySchedule";
import UnderwritePolicy from "./pages/admin/customer/UnderwritePolicy";
import GeneralCoverpolicyConfig from "./pages/admin/policy/GeneralCoverpolicyConfig";
import AuditReport from "./pages/admin/reports/AuditReport";
import ReportDash from "./pages/admin/reports/ReportDash";
import CustomerReport from "./pages/admin/reports/CustomerReport/CustomerReport";
import CustomerOverview from "./pages/admin/reports/CustomerReport/CustomerOverview";
import CustomerPayment from "./pages/admin/reports/CustomerReport/CustomerPayment";
import CustomerPolicyInformation from "./pages/admin/reports/CustomerReport/CustomerPolicyInformation";
import CustomerPolicyExpiry from "./pages/admin/reports/CustomerReport/CustomerPolicyExpiry";
import Cover from "./pages/admin/settings/Cover";
import AddCover from "./pages/admin/settings/cover/AddCover";
import SingleCover from "./pages/admin/settings/cover/SingleCover";
import Claims from "./pages/admin/claims/Claims";
import Workflow from "./pages/admin/workflow/Workflow";
import CreateWorkflow from "./pages/admin/workflow/CreateWorkflow";
import ViewWorkflow from "./pages/admin/workflow/ViewWorkflow";
import Forms from "./pages/admin/settings/Forms";
import CreateForm from "./pages/admin/settings/forms/CreateForm";
import EditForm from "./pages/admin/settings/forms/EditForm";
import ClaimConfiguration from "./pages/admin/settings/ClaimConfiguration";
import AddConfiguration from "./pages/admin/settings/claims/AddConfiguration";
import AllClaims from "./pages/admin/claims/AllClaims";
import EditConfiguration from "./pages/admin/settings/claims/EditConfiguration";
import SingleClaim from "./pages/admin/claims/SingleClaim";

import PolicyReport from "./pages/admin/reports/CustomerReport/PolicyReport";

import CustomerClaims from "./pages/admin/customer/CustomerClaims";
import PolicyCycleView from "./pages/admin/policy/policy-history/PolicyCycleView";
import PolicySingleClaimHistoryView from "./pages/admin/policy/policy-history/PolicySingleClaimHistoryView";
import PolicyRenewal from "./pages/admin/policy/PolicyRenewal";
import PolicyRenewalPreview from "./pages/admin/policy/PolicyRenewalPreview";
import AgentReport from "./pages/admin/reports/AgentReport";
import ClaimReport from "./pages/admin/reports/ClaimReport";
import FinancialReport from "./pages/admin/reports/FinancialReport";
import TrialBalance from "./pages/admin/reports/TrialBalance";
import ChartOfAccounts from "./components/accounting/ChartOfAccounts";
import Journals from "./components/accounting/Journals";
import PendingActions from "./pages/admin/PendingActions/PendingActions";
import Charges from "./pages/admin/settings/charges/Charges";
import CreateCharges from "./pages/admin/settings/charges/CreateCharges";
import RenewedPolicy from "./pages/admin/reports/CustomerReport/RenewedPolicy";
import SingleCharge from "./pages/admin/settings/charges/SingleCharge";
import SavingsPolicy from "./pages/admin/policy/savings-policy/SavingsPolicy";
import CreateSavingsPolicy from "./pages/admin/policy/savings-policy/CreateSavingsPolicy";
import EditSavingsPolicy from "./pages/admin/policy/savings-policy/EditSavingsPolicy";
import MigrationPage from "./pages/admin/migration";
import DocUploadPage from "./pages/admin/migration/DocUploadPage";
import SavingsPolicyApplication from "./pages/admin/customer/Savings-application/SavingsPolicyApplication";
import PreviewSavingsPolicyApplication from "./pages/admin/customer/Savings-application/PreviewSavingsPolicyApplication";
import CustomerSavingsPolicyView from "./pages/admin/customer/Savings-application/CustomerSavingsPolicyView";
import AppliedSavingsPolicies from "./pages/admin/customer/Savings-application/AppliedSavingsPolicies";
import UnderwriteSavingsPolicy from "./pages/admin/customer/Savings-application/UnderwriteSavingsPolicy";
import SavingsPolicyDocument from "./pages/admin/customer/Savings-application/SavingsPolicyDocument";
import { useEffect } from "react";
import SavingsClaimConfiguration from "./pages/admin/settings/SavingsClaimConfiguration";
import AllSavingsClaims from "./pages/admin/claims/savings/AllSavingsClaims";
import SavingsClaims from "./pages/admin/claims/savings/SavingsClaims";
import SingleSavingsClaim from "./pages/admin/claims/savings/SingleSavingsClaim";
import SavingsPreloadedClause from "./pages/admin/settings/SavingsPreloadedClause";
import SavingsPolicyReport from "./pages/admin/reports/SavingsReport/SavingsPolicyReport";
import IndividualSavingsReport from "./pages/admin/reports/SavingsReport/IndividualSavingsReport";
import SavingsAccountReport from "./pages/admin/reports/SavingsReport/SavingsAccountReport";
import SavingsInterestReport from "./pages/admin/reports/SavingsReport/SavingsInterestReport";
import SavingsPerformance from "./pages/admin/reports/SavingsReport/SavingsPerformance";
import SavingsClaimReport from "./pages/admin/reports/SavingsReport/SavingsClaimReport";
import SavingsInformationReport from "./pages/admin/reports/SavingsReport/SavingsInformationReport";
import SavingsContributionPayment from "./pages/admin/reports/SavingsReport/SavingsContributionPayment";
import ResetPassword from "./pages/guest/ResetPassword";
import AgentCustomers from "./pages/admin/user/AgentCustomers";
import CoinsuranceCompanies from "./pages/admin/settings/co-insurance/CoinsuranceCompanies";
import CreditLifePolicy from "./pages/admin/policy/creditlife/CreditLifePolicy";
import CreateCreditLifePolicy from "./pages/admin/policy/creditlife/CreateCreditLifePolicy";
import EditSavingsApplication from "./pages/admin/customer/Savings-application/EditSavingsApplication";

function App() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div className="App">
      <Routes>
        {/* public routes */}
        <Route path="*" element={<Error404 />} />
        <Route path="/" index element={<Login />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="migration" element={<MigrationPage />} />
        <Route path="/upload-document" element={<DocUploadPage />} />

        {/* protected route */}
        <Route element={<RequireAuth />}>
          <Route path="/admin" element={<Main />}>
            <Route path="dashboard" element={<Dashboard />} />

            <Route element={<RedirectStaffOnboarding />}>
              <Route path="add-staff" element={<AddStaff />} />
              <Route
                path="add-staff/contact-information"
                element={<AddContactInformation />}
              />
              <Route
                path="add-staff/education-info"
                element={<AddEducationInfo />}
              />

              <Route
                path="add-staff/employment-information"
                element={<AddEmploymentInfo />}
              />
              <Route
                path="add-staff/guarantor-information"
                element={<AddGuarantorInfo />}
              />
              <Route
                path="add-staff/work-experience"
                element={<AddWorkExperience />}
              />
              <Route
                path="add-staff/next-of-kin-information"
                element={<AddNextOfKin />}
              />
            </Route>

            <Route path="pending-actions" element={<PendingActions />} />
            <Route path="list-of-staffs" element={<ListOfStaff />} />
            <Route path="staff/staff-profile" element={<StaffProfile />} />

            <Route path="add-office" element={<AddOffice />} />
            <Route path="office-list" element={<OfficeList />} />
            <Route path="office-details/:id" element={<OfficeDetails />} />

            {/* policy configuration */}
            <Route
              path="policy-configuration"
              element={<GeneralCoverpolicyConfig />}
            />
            <Route path="all-policies" element={<AllPolicy />} />
            <Route path="edit-policy/:id" element={<EditPolicy />} />
            <Route path="policy-history-cycle" element={<PolicyCycleView />} />
            <Route
              path="view-single-claim-history"
              element={<PolicySingleClaimHistoryView />}
            />

            {/* accounting configuration */}
            {/* <Route path='accounting' element={<Accounting />} /> */}
            <Route
              path="accounting/chart-of-accounts"
              element={<ChartOfAccounts />}
            />
            <Route path="accounting/journals" element={<Journals />} />

            <Route path="settings/roles" element={<Settings />} />
            <Route
              path="settings/preloaded-clauses"
              element={<PreloadedClauses />}
            />
            <Route
              path="settings/preloaded-savings-clauses"
              element={<SavingsPreloadedClause />}
            />
            <Route
              path="settings/preloaded-clauses/:id"
              element={<PreloadedClauseDetail />}
            />
            <Route
              path="settings/preloaded-clauses/add-clause"
              element={<AddClause />}
            />
            <Route
              path="settings/create-permission"
              element={<CreatePermission />}
            />
            <Route path="settings/cover" element={<Cover />} />
            <Route path="settings/cover/:id" element={<SingleCover />} />
            <Route path="settings/cover/add-cover" element={<AddCover />} />

            <Route path="settings/life-cover" element={<Charges />} />
            <Route
              path="settings/life-cover/add-life-cover"
              element={<CreateCharges />}
            />
            <Route path="settings/life-cover/:id" element={<SingleCharge />} />
            {/* coinsurance */}
            <Route path="co-insurance" element={<CoinsuranceCompanies />} />

            {/* claims routes */}
            {/* <Route path='' element={<Claims />} /> */}
            <Route path="claims" element={<Claims />} />
            <Route path="savings-claims" element={<SavingsClaims />} />
            <Route path="claims/all-claims" element={<AllClaims />} />
            <Route
              path="claims/all-savings-claims"
              element={<AllSavingsClaims />}
            />
            <Route
              path="claims/all-savings-claims/edit"
              element={<SingleSavingsClaim />}
            />
            <Route path="claims/edit" element={<SingleClaim />} />
            <Route
              path="claims/history"
              element={<PolicySingleClaimHistoryView />}
            />
            <Route
              path="settings/savings-claim-configuration"
              element={<SavingsClaimConfiguration />}
            />
            <Route
              path="settings/claim-configuration"
              element={<ClaimConfiguration />}
            />
            <Route
              path="settings/claim-configuration/add"
              element={<AddConfiguration />}
            />
            <Route
              path="settings/claim-configuration/:id"
              element={<EditConfiguration />}
            />

            {/*Create Forms routes */}
            <Route path="settings/forms" element={<Forms />} />
            <Route path="settings/forms/add-form" element={<CreateForm />} />
            <Route path="settings/forms/:id" element={<EditForm />} />
            <Route path="settings/forms" element={<Forms />} />
            <Route path="settings/forms/add-form" element={<CreateForm />} />
            <Route path="settings/forms/:id" element={<EditForm />} />

            {/* Policy config, and application routes */}
            <Route
              path="policy-application"
              element={<PolicyApplicationSettings />}
            />
            <Route
              path="policy-application/edit"
              element={<EditAppliedPolicy />}
            />
            <Route
              path="policy-application/overview"
              element={<PolicyApplicationOverview />}
            />
            <Route
              path="all-applied-general-policies"
              element={<AppliedPolicies />}
            />
            <Route
              path="all-applied-savings-policies"
              element={<AppliedSavingsPolicies />}
            />
            <Route
              path="attach-customer"
              element={<PolicyAttachmentSearch />}
            />
            <Route
              path="customer-policies/:id"
              element={<PolicyInformation />}
            />
            <Route
              path="policy-application/renewal"
              element={<PolicyRenewal />}
            />
            <Route
              path="policy-renewal/preview"
              element={<PolicyRenewalPreview />}
            />

            <Route
              path="customer-policy-view"
              element={<CustomerPolicyView />}
            />
            <Route
              path="customer-policy-view/underwrite"
              element={<UnderwritePolicy />}
            />
            <Route
              path="customer-policy-view/policy-schedule"
              element={<PolicySchedule />}
            />

            <Route path="credit-life" element={<CreditLifePolicy />} />
            <Route
              path="credit-life/create"
              element={<CreateCreditLifePolicy />}
            />
            {/* Savings policy routes */}
            <Route path="savings-policy" element={<SavingsPolicy />} />
            <Route
              path="edit-savings-policy/:id"
              element={<EditSavingsPolicy />}
            />
            <Route
              path="savings-policy/create"
              element={<CreateSavingsPolicy />}
            />
            <Route
              path="savings-policy/application"
              element={<SavingsPolicyApplication />}
            />
            <Route
              path="savings-policy/application-preview"
              element={<PreviewSavingsPolicyApplication />}
            />
            <Route
              path="customer-savings-policy-view"
              element={<CustomerSavingsPolicyView />}
            />
            <Route
              path="customer-savings-policy-view/edit"
              element={<EditSavingsApplication />}
            />
            <Route
              path="customer-savings-policy-view/underwrite"
              element={<UnderwriteSavingsPolicy />}
            />
            <Route
              path="customer-savings-policy-view/policy-schedule"
              element={<SavingsPolicyDocument />}
            />

            <Route
              path="customer-claims/:customer_id"
              element={<CustomerClaims />}
            />

            {/*create, edit, and customers profile routes  */}
            <Route path="add-customer" element={<AddCustomer />} />
            {/* <Route path='customer-overview' element={<CustomerOverview />} /> */}
            <Route path="individual-customers" element={<AllCustomer />} />
            <Route
              path="corporate-customers"
              element={<CorporateCustomerTable />}
            />
            <Route path="customer-profile/:id" element={<CustomerProfile />} />

            {/* user routes */}
            <Route path="add-user" element={<AddUser />} />
            <Route path="all-users" element={<AllUser />} />
            <Route path="user/user-profile/:id" element={<UserProfile />} />
            <Route
              path="user/user-profile/:id/customers"
              element={<AgentCustomers />}
            />
            <Route path="user/edit-user/:id" element={<EditUser />} />

            {/* Report routes */}
            <Route path="reports" element={<ReportDash />} />
            <Route
              path="reports/customer-report"
              element={<CustomerReport />}
            />
            <Route path="reports/policy-report" element={<PolicyReport />} />

            <Route path="reports/agent-report" element={<AgentReport />} />
            <Route
              path="reports/financial-report"
              element={<FinancialReport />}
            />
            <Route
              path="reports/financial-report/trial-balance"
              element={<TrialBalance />}
            />
            <Route path="reports/policy-report" element={<PolicyReport />} />
            <Route path="reports/claim-report" element={<ClaimReport />} />
            <Route
              path="reports/customer-overview"
              element={<CustomerOverview />}
            />
            <Route
              path="reports/customer-payment"
              element={<CustomerPayment />}
            />
            <Route path="reports/claims-report" element={<ClaimReport />} />

            <Route
              path="reports/savings-policy-report"
              element={<SavingsPolicyReport />}
            />
            <Route
              path="reports/savings-policy-report/individual-savings-report"
              element={<IndividualSavingsReport />}
            />
            <Route
              path="reports/savings-policy-report/savings-account-balance"
              element={<SavingsAccountReport />}
            />
            <Route
              path="reports/savings-policy-report/interest-report"
              element={<SavingsInterestReport />}
            />
            <Route
              path="reports/savings-policy-report/savings-performance-report"
              element={<SavingsPerformance />}
            />
            <Route
              path="reports/savings-policy-report/savings-claim-report"
              element={<SavingsClaimReport />}
            />
            <Route
              path="reports/savings-policy-report/savings-policy-information"
              element={<SavingsInformationReport />}
            />
            <Route
              path="reports/savings-policy-report/savings-contribution-payment"
              element={<SavingsContributionPayment />}
            />
            <Route
              path="reports/policy-report/policy-information"
              element={<CustomerPolicyInformation />}
            />
            <Route
              path="reports/policy-report/policy-expiry"
              element={<CustomerPolicyExpiry />}
            />
            <Route
              path="reports/policy-report/renewed-policy"
              element={<RenewedPolicy />}
            />
            <Route path="reports/audit-report" element={<AuditReport />} />

            {/* workflow */}
            <Route path="workflow" element={<Workflow />} />
            <Route path="workflow/create" element={<CreateWorkflow />} />
            <Route path="workflow/view/:id" element={<ViewWorkflow />} />

            {/* <Route path='commissions' element={<Commissions />} />
            <Route path='commissions/add' element={<AddCommission />} />
            <Route path='commissions/:id' element={<CommissionDetails />} /> */}

            <Route path="*" element={<Error404 />} />
          </Route>
        </Route>
      </Routes>
      {/* flash message */}
      <ToastContainer />
    </div>
  );
}

export default App;
